@if (_active) {
  <kendo-window
    title="{{ _isPageCategory == true ? 'Category Per Account' :  _isPageVendors == true ? 'Vendors Per Account' : _isPageAddresses == true ? 'Addresses Per Account' : _isPageLocation == true ? 'Locations Per Account' : _isPageLocationType == true ? 'Location Type Per Account' : _isPageUsers == true ? 'Users Per Account' : 'Quantity Per Account' }}"
    (keydown.enter)="$event.preventDefault()"
    (close)="_closeForm()" (stateChange)="_onStateChanges($event)" [class.singleDonutPopup]="_isSingleDonutPopup">
    <div class="col-12 donut-form-container">
      @for (chart of _donutChartLarge; track chart) {
        <div class="donut-component-single-container">
          <asap-donut-chart class="" [model]="chart" [chartTooltip]="_tooltipVisibilityForm">
          </asap-donut-chart>
          <div class="dont-chart-title">{{chart.title}}</div>
        </div>
      }
    </div>
  </kendo-window>
}
